<h1 mat-dialog-title>{{ 'dataEvaluation.viewEvaluations.quantities.dialogTitle' | transloco }}</h1>

<mat-dialog-content id="dialog-content">
  <mat-tab-group>
    <mat-tab label="{{ 'dataEvaluation.viewEvaluations.quantities.packagingSystemsTab' | transloco }}">
      <app-aggregated-quantities-table [quantities]="packagingSystemQuantities"
                                       [idFieldName]="'dataEvaluation.viewEvaluations.quantities.table.packagingSystemId' | transloco" />
    </mat-tab>

    <mat-tab label="{{ 'dataEvaluation.viewEvaluations.quantities.packagingUnitsTab' | transloco }}">
      <app-aggregated-quantities-table [quantities]="packagingUnitQuantities"
                                       [idFieldName]="'dataEvaluation.viewEvaluations.quantities.table.packagingUnitId' | transloco" />
    </mat-tab>
  </mat-tab-group>

</mat-dialog-content>

<mat-dialog-actions>
  <button (click)="closeDialog()" mat-raised-button type="button">{{ 'common.buttons.close' | transloco }}</button>
</mat-dialog-actions>
